<style scoped>
  .ef-searchable-dropdown {
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    width: 100%;
    padding: 0px;
    margin-right: 10px;
  }
  .form-control {
    border-radius: 5px;
    font-size: 16px;
  }
  .search-arrow {
    position: absolute;
    right: 6px;
    top: 15px;
    color: #4E5154;
    font-size: 14px;
  }
  .baseEvent .search-arrow {
    right: 10px;
    top: 10px;
    font-size: 16px;
  }
  .search-box input {
    width: 100%;
    display: inline-flex;
  }
  .search-list .search-box {
    margin: 5px;
  }
  .search-list {
    position: absolute;
    top: 42px;
    left: 0;
    width: 100%;
    border: 1px solid #E0E7FF;
    background-color: #fff;
    color: #4E5154;
    border-radius: 5px;
    z-index: 500;
    margin-bottom: 10px;
  }
  .search-list ul {
    display: block;
    max-height: 120px;
    overflow-y: scroll;
    padding: 0;
    margin: 0;
  }
  .search-list ul > li { 
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25;
    list-style-type: none;
    margin-left: 0;
    padding: 10px 8px;
  }
  .search-list ul > li:hover {
    background-color: #E0E0E0;
  }
  .search-list ul > li.highlighted {
    background-color: #E0E0E0;
  }
  .ef-searchable-dropdown.disabled .form-control {
    background-color: #ECEFF1;
    border: 1px solid #E0E7FF;
    color: #7a7e82;
  }
  .ef-searchable-dropdown.disabled .search-arrow {
    color: #7a7e82;
  }
</style>

<template>
  <div class="ef-searchable-dropdown" :class="{ customClass: (customClass != undefined), expanded: focusSearch, disabled: (disabled !== undefined && disabled == true) }">
      <input type="hidden" v-model="value">

      <div class="searchbox-container" @click="openListView" aria-haspopup="true" role="button" aria-label="Open Dropdown Search" @focus="openListView" :tabindex="inputFieldTabindex">
          <span v-if="(selectedText === '' || selectedText === null)" class="disabled form-control" v-html="placeholderText"></span>
          <span v-if="(selectedText !== '' && selectedText !== null)" class="form-control" v-html="selectedText"></span>
          <i class="search-arrow fas fa-angle-down"></i>
      </div>

      <div class="search-list light-shadow" v-show="focusSearch" :aria-expanded="( focusSearch ? 'true' : 'false')">
        <div class="search-box">
          <label class="hide" :for="inputFieldId">Search Dropdown Options</label>
          <input type="text" v-model="optionSearch" class="form-control" ref="optionssearch" @keydown.esc="closeListView" :id="inputFieldId" @focusout="closeListView">
        </div>

        <ul tabindex="-1" role="select">
          <li v-for="option in filteredOptions" 
            :data-value="option.value" 
            v-html="option.text"
            :class="{ 'highlighted' : (selectedValue == option.value) }"
            :aria-selected="(selectedValue == option.value)"
            @click="selectOption(option)"
            @keydown.enter="selectOption(option)"
            tabindex="0"  
            role="option"
          ></li>
        </ul>
      </div>
  </div>
</template>

<script>
  export default {
    props: ['value', 'options', 'defaultOption', 'customClass', 'disabled', 'canAdd', 'inputId', 'inputTabindex', 'pageName'],

    data: function () {
      return {
        loading: false,
        focusSearch: false,
        optionSearch: null,
        selectedText: this.selectedText,
        selectedValue: this.selectedValue
      }
    },

    created: function () {
      this.selectedText = ''
      this.selectedValue = this.value
    },

    mounted: function () {
      this.updateSelectedOption()
    },

    methods: {
      openListView: function() {
        if (this.disabled !== undefined && this.disabled == true) {
          return false;
        }

        this.focusSearch = true;
        var self = this
        setTimeout(function () {
            self.$refs.optionssearch.focus();
        }, 150)
      },
      closeListView: function() {
        var self = this
        setTimeout(function () {
          self.focusSearch=false;
        }, 200)
      },
      unselectOption: function() {
        this.selectedText = '';
        this.$emit('input', '');
        this.$emit('change', '');
      },
      selectOption: function(option) {
        this.selectedText = option.text;
        this.selectedValue = option.values;
        this.$emit('input', option.value);
        this.$emit('change', option.value);
        this.optionSearch = '';
        this.closeListView();
      },
      updateSelectedOption: function() {
        var selectedOption = this.options.filter(option => {
            return (option.value === this.selectedValue)
        })
        if (selectedOption.length > 0) {
          this.selectedText = selectedOption[0].text
        }
        
        if (this.selectedText == '' && this.canAdd) {
          this.selectedText = this.selectedValue
        }
      }
    },

    computed: {
      placeholderText: function () {
        if (this.defaultOption && this.defaultOption === 'null') {
          if (this.options && this.options.length > 0) {
              return this.options[0].text
          }
          return ' Choose One '
        }
        return this.defaultOption ? this.defaultOption : ' Choose One '
      },
      filteredOptions: function () {
        if (this.options) {
          var filtered = this.options.filter(option => {
            if (this.optionSearch != null) {
              if (option.value !== null && option.value !== undefined) {
                return (option.value.toString().toLowerCase().includes(this.optionSearch.toLowerCase()) 
                  || option.text.toLowerCase().includes(this.optionSearch.toLowerCase()))
              } else {
                return option.text.toLowerCase().includes(this.optionSearch.toLowerCase())
              }
            } else {
              return this.options
            }
          })
          
          if (this.canAdd && this.optionSearch) {
            var search = { value: this.optionSearch , text: this.optionSearch }
            if(filtered.filter(f => f.value.toString().toLowerCase() == search.value.toString().toLowerCase()).length == 0) filtered.unshift(search)
          }
          return filtered
        } else {
          return []
        }
      },
      inputFieldId: function () {
        if (this.inputId && this.inputId !== '') {
          return this.inputId
        } else {
          return ''
        }
      },
      inputFieldTabindex: function () {
        if (this.inputTabindex) {
          return this.inputTabindex
        } else {
          return 0
        }
      },
    },

    watch: {
      value: function(newValue, oldValue) {
        this.selectedText = ''
        this.selectedValue = newValue
        this.updateSelectedOption()
      },
      optionSearch: function (newValue, oldValue) {
        var self = this;
        setTimeout(function (newValue) {
          if (newValue !== null && newValue == self.optionSearch && self.pageName == 'badge-edit') {
            updateOptionValue()
          }
        }, 400, newValue, oldValue)

        function updateOptionValue() {
          self.$parent.updateAttendeeSearch(self.optionSearch)
        }
      }
    }
  }
</script>
